import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { storiescoach, successcoach } from "../../../../assets";
import { fontWeight } from "@mui/system";


interface CounterProps {
  end: number;
  prefix?: string;
  suffix?: string;
  duration?: number;
}

const Counter: React.FC<CounterProps> = ({
  end,
  prefix = "",
  suffix = "",
  duration = 2000,
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime: number;
    let animationFrame: number;

    const animate = (time: number) => {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / duration, 1);
      const value = progress * end;

      setCount(value);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration]);

  return (
    <Typography
      variant="h6"
      sx={{
        fontSize: { xs: "28px", md: "40px" },
        fontWeight: 800,
        color: "#ffffff",
      }}
    >
      {prefix}
      {Math.floor(count)}
      {suffix}
    </Typography>
  );
};


const SuccessStorySection: React.FC = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: "#f5f9ff" }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 10 } }}>
        <Box
          sx={{
            position: "relative",
            borderRadius: "30px",
            overflow: "hidden",
            minHeight: { xs: 'auto', md: "500px" },
            display: "flex",
            alignItems: "center",
            px: { xs: 4, md: 4 },
            py: { xs: 6, md: 0 },

            // backgroundImage: `
            //   linear-gradient(
            //     90deg,
            //     rgba(15,99,165,0.92) 0%,
            //     rgba(15,99,165,0.85) 35%,
            //     rgba(15,99,165,0.65) 65%,
            //     rgba(15,99,165,0.3) 100%
            //   ),
            //   url(${successcoach})
            // `,
            backgroundImage: `
              linear-gradient(
                90deg,
                rgba(15,99,165,0.92) 0%,
                rgba(15,99,165,0.85) 35%,
                rgba(15,99,165,0.65) 65%,
                rgba(15,99,165,0.3) 100%
              ),
              url("https://dprstorage.b-cdn.net/RW/leadgen/rw%20img%2052546%20(1).png")
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* LEFT CONTENT WRAPPER (Fixed Width Like Screenshot) */}
          <Box
            sx={{
              maxWidth: "620px",
              //   px: { xs: 4, md: 10 },
              //   py: { xs: 8, md: 10 },
              color: "white",
            }}
          >
            {/* Heading */}
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "32px", md: "48px" },
                fontWeight: 800,
                lineHeight: 1.2,
                mb: 2,
                color: "white",
                textAlign: { xs: "center", md: "start" },

                /* Strong dark stroke for contrast */
                WebkitTextStroke: "1.5px rgba(0,0,0,0.7)",

                /* Depth shadow for premium look */
                textShadow: `
      0 4px 12px rgba(0,0,0,0.6),
      0 2px 4px rgba(0,0,0,0.5)
    `,
              }}
            >
              YOUR NEXT LEVEL STARTS HERE

            </Typography>


            {/* Paragraph */}
            <Typography
              sx={{
                fontSize: "18px",
                opacity: 0.95,
                lineHeight: 1.8,
                // mb: 6,
                color: "white",
                textAlign: { xs: "center", md: "start" },
              }}
            >
              Stop relying only on effort.
              <br />
              Start operating with <b> structure, authority, and predictable sales momentum.</b>

            </Typography>
            {/* <Typography
              sx={{
                fontSize: "18px",
                opacity: 0.95,
                lineHeight: 1.8,

                color: "white",
                textAlign: 'start'
              }}
            >
              Whether you are an ambitious sales professional or a business building a high-performing team — the difference between average and elite is not motivation.
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                opacity: 0.95,
                lineHeight: 1.8,
                mb: 6,
                color: "white",
                textAlign: 'start'
              }}>
              It’s architecture.
            </Typography> */}

            {/* Counters Row */}
            <Grid container spacing={4} mt={1}>
              {/* Stat 1 */}
              <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontSize: { xs: "42px", md: "52px" },
                    fontWeight: 900,
                    background: "linear-gradient(90deg, #ffffff, #d7dde1)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    letterSpacing: "1px",
                    textShadow: "0 4px 12px rgba(0,0,0,0.5)",
                  }}
                >
                  <Counter end={3} suffix="X" />
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.85,
                    color: "white",
                    mt: 1,
                    fontSize: "16px",
                    letterSpacing: "0.5px",
                  }}
                >
                  Stronger Sales Conversations

                </Typography>
              </Grid>

              {/* Stat 3 */}
              <Grid item xs={12} md={4}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "42px", md: "52px" },
                    fontWeight: 900,
                    background: "linear-gradient(90deg, #ffffff, #d7dde1)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    letterSpacing: "1px",
                    textShadow: "0 4px 12px rgba(0,0,0,0.5)",
                  }}
                >
                  <Counter end={5} suffix="X" />
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.85,
                    color: "white",
                    mt: 1,
                    fontSize: "16px",
                    letterSpacing: "0.5px",
                  }}
                >
                  Higher Client Confidence
                </Typography>
              </Grid>

              {/* Stat 2 */}
              <Grid item xs={12} md={4}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "42px", md: "52px" },
                    fontWeight: 800,
                    background: "linear-gradient(90deg, #ffffff, #d7dde1)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    letterSpacing: "1px",
                    textShadow: "0 4px 12px rgba(0,0,0,0.5)",
                  }}
                >
                  <Counter end={100}  suffix="%" />
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.85,
                    color: "white",
                    mt: 1,
                    fontSize: "16px",
                    letterSpacing: "0.5px",
                  }}
                >
                  Framework-Driven Sales Process

                </Typography>
              </Grid>

              
            </Grid>


          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SuccessStorySection;
